import AzHome from './components/AZ/Home.vue'
import AzSip from './components/AZ/Sip.vue'
import AzOrder from './components/AZ/Order.vue'
import Main from './components/AZ/Main.vue'

import RuHome from './components/RU/Home.vue'
import RuSip from './components/RU/Sip.vue'
import RuOrder from './components/RU/Order.vue'

import EnHome from './components/EN/Home.vue'
import EnSip from './components/EN/Sip.vue'
import EnOrder from './components/EN/Order.vue'

export const routes = [
    { path: '/', component: Main },
    { path: '/az', component: AzHome },
    { path: '/az/sip/:id/:pageNumber/:sortBy/:orderBy', component: AzSip},
    { path: '/az/sip/order/:number', component: AzOrder },
    { path: '/az/*', redirect: '/az'},

    { path: '/ru', component: RuHome },
    { path: '/ru/sip/:id/:pageNumber/:sortBy/:orderBy', component: RuSip},
    { path: '/ru/sip/order/:number', component: RuOrder },
    { path: '/ru/*', redirect: '/ru'},

    { path: '/en', component: EnHome },
    { path: '/en/sip/:id/:pageNumber/:sortBy/:orderBy', component: EnSip},
    { path: '/en/sip/order/:number', component: EnOrder },
    { path: '/en/*', redirect: '/en'},
    { path: '/**', redirect: '/'}
];


// WEBPACK FOOTER //
// ./src/routes.js